// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Accounting status — editable mode matches CMS Select dropdowns
   (white field, clear border, navy focus). Static mode stays a status pill. */
.pv-accounting-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.pv-accounting-status__dot {
  width: 8px;
  height: 8px;
  flex: none;
  border-radius: 50%;
}
.pv-accounting-status__label {
  color: inherit;
  font-size: 14px;
  font-weight: 600;
}
.pv-accounting-status__option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
}
.pv-accounting-status--static {
  /* Match InvertFillButton size="sm" (Download Voucher Report). */
  height: 36px;
  padding: 0 20px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
.pv-accounting-status--editable {
  /* Same height + type as Download Voucher Report (size=sm, font=14/600). */
  min-width: 200px;
}
.pv-accounting-status--editable .ant-select {
  width: 100%;
  min-width: 200px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}
.pv-accounting-status--editable .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 20px !important;
  background: #ffffff !important;
  border: 1.5px solid #94a3b8 !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  display: flex;
  align-items: center;
}
.pv-accounting-status--editable .ant-select:hover:not(.ant-select-disabled) .ant-select-selector,
.pv-accounting-status--editable .ant-select-focused:not(.ant-select-disabled) .ant-select-selector,
.pv-accounting-status--editable .ant-select-open .ant-select-selector {
  border-color: #004195 !important;
  box-shadow: 0 0 0 2px rgba(0, 65, 149, 0.12) !important;
}
.pv-accounting-status--editable .ant-select-selection-item {
  padding-right: 22px !important;
  color: #0f172a !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 34px !important;
  opacity: 1 !important;
}
.pv-accounting-status--editable .ant-select-arrow {
  right: 12px;
  color: #004195;
  font-size: 12px;
  opacity: 1;
}
.pv-accounting-status--editable .ant-select-disabled .ant-select-selector {
  background: #f8fafc !important;
  color: #64748b !important;
}
.pv-accounting-status--saving {
  opacity: 0.85;
  cursor: progress;
}
.pv-accounting-status--block {
  display: flex;
  width: 100%;
}
.pv-accounting-status--block .ant-select {
  width: 100%;
}

.pv-accounting-status-dropdown {
  padding: 6px;
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.06);
}
.pv-accounting-status-dropdown .ant-select-item {
  border-radius: 7px;
  font-size: 14px;
  font-weight: 600;
  min-height: 40px;
  line-height: 40px;
}
.pv-accounting-status-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: #eef4ff;
  color: #004195;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/PaymentVoucher/PaymentVoucher.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;8EAAA;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAEF;AAAE;EACE,UAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AAEJ;AACE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,gEAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAIE;EACE,0EAAA;EACA,gBAAA;AAFJ;AAII;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFN;AAKI;EACE,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;EACA,sCAAA;EACA,6BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AAHN;AAMI;;;EAGE,gCAAA;EACA,uDAAA;AAJN;AAOI;EACE,8BAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,qBAAA;AALN;AAQI;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AANN;AASI;EACE,8BAAA;EACA,yBAAA;AAPN;AAWE;EACE,aAAA;EACA,gBAAA;AATJ;AAYE;EACE,aAAA;EACA,WAAA;AAVJ;AAYI;EACE,WAAA;AAVN;;AAeA;EACE,YAAA;EACA,mBAAA;EACA,+EACE;AAbJ;AAgBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAfJ","sourcesContent":["/* Accounting status — editable mode matches CMS Select dropdowns\n   (white field, clear border, navy focus). Static mode stays a status pill. */\n.pv-accounting-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n\n  &__dot {\n    width: 8px;\n    height: 8px;\n    flex: none;\n    border-radius: 50%;\n  }\n\n  &__label {\n    color: inherit;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  &__option {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #0f172a;\n  }\n\n  &--static {\n    /* Match InvertFillButton size=\"sm\" (Download Voucher Report). */\n    height: 36px;\n    padding: 0 20px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1;\n  }\n\n  &--editable {\n    /* Same height + type as Download Voucher Report (size=sm, font=14/600). */\n    min-width: 200px;\n\n    .ant-select {\n      width: 100%;\n      min-width: 200px;\n      font-size: 14px;\n      font-weight: 600;\n      color: #0f172a;\n    }\n\n    .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n      height: 36px !important;\n      min-height: 36px !important;\n      padding: 0 20px !important;\n      background: #ffffff !important;\n      border: 1.5px solid #94a3b8 !important;\n      border-radius: 8px !important;\n      box-shadow: none !important;\n      display: flex;\n      align-items: center;\n    }\n\n    .ant-select:hover:not(.ant-select-disabled) .ant-select-selector,\n    .ant-select-focused:not(.ant-select-disabled) .ant-select-selector,\n    .ant-select-open .ant-select-selector {\n      border-color: #004195 !important;\n      box-shadow: 0 0 0 2px rgba(0, 65, 149, 0.12) !important;\n    }\n\n    .ant-select-selection-item {\n      padding-right: 22px !important;\n      color: #0f172a !important;\n      font-size: 14px !important;\n      font-weight: 600 !important;\n      line-height: 34px !important;\n      opacity: 1 !important;\n    }\n\n    .ant-select-arrow {\n      right: 12px;\n      color: #004195;\n      font-size: 12px;\n      opacity: 1;\n    }\n\n    .ant-select-disabled .ant-select-selector {\n      background: #f8fafc !important;\n      color: #64748b !important;\n    }\n  }\n\n  &--saving {\n    opacity: 0.85;\n    cursor: progress;\n  }\n\n  &--block {\n    display: flex;\n    width: 100%;\n\n    .ant-select {\n      width: 100%;\n    }\n  }\n}\n\n.pv-accounting-status-dropdown {\n  padding: 6px;\n  border-radius: 10px;\n  box-shadow:\n    0 6px 16px rgba(15, 23, 42, 0.12),\n    0 2px 6px rgba(15, 23, 42, 0.06);\n\n  .ant-select-item {\n    border-radius: 7px;\n    font-size: 14px;\n    font-weight: 600;\n    min-height: 40px;\n    line-height: 40px;\n  }\n\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background-color: #eef4ff;\n    color: #004195;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
